var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tooltip',{attrs:{"visible":_vm.process,"placement":"bottomLeft"}},[_c('div',{staticClass:"p-all share-tooltip",attrs:{"slot":"title"},slot:"title"},[_vm._v(" "+_vm._s(_vm.$t("Share about"))+" ")]),_c('a-button',{staticClass:"demo__button",class:{
      'share-button-ok': _vm.process,
      'demo__button--base': !_vm.process,
      this__btn: _vm.windowWidth > 1630,
    },on:{"click":_vm.copy}},[_c('div',{staticClass:"share-button-inner"},[_c('i',{staticClass:"fa-light",class:{
          'fa-check': _vm.process_text,
          'fa-share-nodes': !_vm.process_text,
        }}),(_vm.windowWidth > 1630)?_c('span',{staticClass:"demo__margin-left--9"},[_vm._v(_vm._s(_vm.process_text ? this.$t("Share done") : this.$t("Share")))]):_vm._e()])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }